import _ from 'lodash';
import { IFace, initialFace } from "./face";
import { IMatchesViewState } from 'src/modules/AdHocTools/Matches/MatchesView';

export interface IMatch {
    matchId: string;
    originFaceId: string;
    matchFaceId: string;
    originFace: IFace;
    matchFace: IFace;
    similarity: number;
    childId?: string;
    caseId?: string;
    searchId?: string;
    metadata?: { // only with webiq
        fetchTime: number;
        url: string;
        face: "originFace" | "matchFace" // originFace or matchFace
    };
    details?: {
        detectResults: IBiometricaDetectResults[];
        photoFace: { url: string };
        suspects: IBiometricaSuspect[];
    }
}

export const initialMatch: IMatch = {
    matchId: "",
    originFaceId: "",
    matchFaceId: "",
    originFace: initialFace,
    matchFace: initialFace,
    similarity: 0.9
}

export interface IMatchResponse {
    matches: IMatch[];
    caseInfo: any,
    childInfo: any,
    matchInfo: IMatch | any;
}
interface IRequestMatchesRange {
    date: { gte: number, lte: number }
}
export interface IRequestMatches {
    page: number;
    size: number;
    sort: Array<{ [key: string]: { order: 'asc' | 'desc' } }>;
    range: IRequestMatchesRange | null;
    search: string;
    filterType: string;
    provider: MatchesProviders;
}

export interface IViewMatch {
    agencyCode: string,
    birthDate: any,
    caseId: string,
    childId: string,
    circumstances: string,
    city: string,
    contactInformation: string,
    country: string,
    fullName: string,
    images: any,
    date: any,
    matchFace: any,
    matchFaceId: string,
    matchId: string,
    missingDate: any,
    openDate: any,
    originFace: any,
    originFaceId: string,
    searchId: string,
    sex: string,
    similarity: number,
    state: string,
    suspects?: number;
    photoFace?: { url: string };
}

export interface IMatchViewResponse {
    matches: {
        total: number,
        results: IViewMatch[]
    }
}

export const initialMatchResults = {
    matches: {
        total: 0,
        results: []
    }
}

export interface IBiometricaSuspect {
    id: string,
    fullName: string,
    dateOfBirth: string,
    nationality: string,
    race: string,
    eyesColor: string,
    hairColor: string,
    gender: string,
    height: string,
    weight: string,
    matchFace: any,
    description: string,
    date: string,
    rank: string,
    similarity: number,
    information?: {
        arrestBinderList: IArrestBinderList[];
        caseBinderList: ICaseBinderList[];
        chargeBinderList: IChargeBinderList[];
    }
}


export interface IArrestBinderList {
    id: string;
    references: any[];
    event_id: string;
    arrestNumber: string;
    bookingDate: string;
    dateReleased: string;
    badge: string;
    arrestingAgency: string;
    arrestDate: string;
    inmateClassification: string;
    address: string;
    facility: string;
    retrievedOn: string;
    dateOfBirth: string;
    age: number
}

export interface ICaseBinderList {
    id: string;
    references: any[];
    event_id: string;
    arrestNumber: string;
    status: string;
    bondType: string;
    bondAmount: string;
    fineAmount: string;
    sentence: string;
}

export interface IChargeBinderList {
    id: string;
    references: any[];
    event_id: string;
    arrestNumber: string;
    chargeId: string;
    crimeType: string;
    chargeDescription: string;
    bondAmount: string;
    chargeStatus: string;
    arrestDate: string;
    arrestingAgency: string;
}

export interface IBiometricaDetectResults {
    rectX: string,
    rectY: string,
    rectHeight: string,
    rectWidth: string
}

export enum FilterOptions {
    All = 'All',
    Automatic = 'Automatic',
    Manual = 'Manual'
}

export enum MatchesProviders {
    Children = 'Children',
    Biometrica = 'Biometrica'
}

export const initialStateMatchView: IMatchesViewState = {
    sort: [{ "date": "desc" }],
    sortName: 'date',
    search: '',
    page: 0,
    size: 12,
    dateRange: {
        startDate: null,
        endDate: null,
        focus: null
    },
    data: _.cloneDeep(initialMatchResults),
    loading: true,
    fetchingData: false,
    pages: 0,
    deleting: false,
    filterType: FilterOptions.All,
    provider: MatchesProviders.Children
}
